/* Component Dependencies */
var diningTemplate = require('templates/dining.hbs');
var diningHotelDetailsTemplate = require('templates/dining-hotelDetails.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
    type: 'dining',
    template: {
        'dining': diningTemplate,
        'dining-hotelDetails': diningHotelDetailsTemplate
    }
});